export default {
  "singles": "Alleinstehende sind überdurchschnittlich häufig von Armut bedroht.",
  "couple_no_children": "Paare ohne Kinder erreichen häufig die oberen Einkommensbereiche.",
  "couple_with_children": "Familien mit Kindern gehören besonders häufig zur Mittelschicht.",
  "u25": "Junge Menschen finden sich eher im unteren Einkommensbereich wieder.",
  "25_49": "Die mittlere Altersgruppe verteilt sich in etwa wie der Durchschnitt der Gesamtbevölkerung.",
  "50_64": "Kurz vor dem Ruhestand ist das Einkommen in der Regel am höchsten.",
  "65_plus": "Das Armutsrisiko im Ruhestandsalter ist unterdurchschnittlich – Altersarmut selten.",
  "edu_low": "Personen mit niedrigem Bildungsabschluss sind häufig von Armut bedroht.",
  "edu_mid": "Wer über ein mittleres Bildungsniveau verfügt, gehört häufig zur Mittelschicht.",
  "edu_high": "Fast jeder Zweite mit akademischem Abschluss gehört zu den oberen Schichten.",
  "full": "Eine Vollzeittätigkeit erhöht die Chance, die oberen Einkommensschichten zu erreichen.",
  "part": "Eine Teilzeittätigkeit geht mit einem geringfügig überdurchschnittlichen Armutsrisiko einher.",
  "not_work": "Wer nicht erwerbstätig ist, ist einem relativ großen Armutsrisiko ausgesetzt.",
  "west": "In Westdeutschland lebt eine breite Mittelschicht – anteilig deutlich größer als im Osten.",
  "east": "Ostdeutsche haben geringere Einkommen – aber auch geringere Lebenshaltungskosten.",
  "ger": "Seit Jahren zählt etwa jeder zweite Deutsche ohne Migrationshintergrund zur Mittelschicht.",
  "foreign": "Menschen mit Migrationshintergrund haben ein deutlich erhöhtes Armutsrisiko.",
  "alleinerz": "Alleinerziehende Elternteile sind einem großen Armutsrisiko ausgesetzt."
}



/** WEBPACK FOOTER **
 ** ./src/modules/infoSets.js
 **/